/**
 * @generated SignedSource<<415c8f4b31fa2e9d1fbf70d40e4da533>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type McpServersOnboardingContentQuery$variables = Record<PropertyKey, never>;
export type McpServersOnboardingContentQuery$data = {
  readonly customMcpServers: ReadonlyArray<{
    readonly authType: string;
    readonly description: string | null | undefined;
    readonly id: any;
    readonly isActive: boolean;
    readonly name: string;
    readonly toolCount: number;
    readonly url: string;
  }>;
};
export type McpServersOnboardingContentQuery = {
  response: McpServersOnboardingContentQuery$data;
  variables: McpServersOnboardingContentQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "GraphQLCustomMcpServer",
    "kind": "LinkedField",
    "name": "customMcpServers",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "name",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "description",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "url",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "authType",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "isActive",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "toolCount",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "McpServersOnboardingContentQuery",
    "selections": (v0/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "McpServersOnboardingContentQuery",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "8d0f5937d64d6d3a39fa09ecf1d332c9",
    "id": null,
    "metadata": {},
    "name": "McpServersOnboardingContentQuery",
    "operationKind": "query",
    "text": "query McpServersOnboardingContentQuery {\n  customMcpServers {\n    id\n    name\n    description\n    url\n    authType\n    isActive\n    toolCount\n  }\n}\n"
  }
};
})();

(node as any).hash = "db4e1ac34a5c9949bcf01a08eacf2392";

export default node;
